/**
 * Pass-through adapter around cm-chessboard.
 * Forwards every method and property so the existing app can keep calling
 * destroy / enableMoveInput / setPosition / addMarker / removeMarkers /
 * showPromotionDialog / view.svg without a board rewrite.
 */
export function wrapChessboard<T extends object>(board: T): T {
  return new Proxy(board, {
    get(target, prop) {
      const value = (target as Record<PropertyKey, unknown>)[prop];
      if (typeof value === "function") {
        return (value as (...args: unknown[]) => unknown).bind(target);
      }
      return value;
    },
  });
}
